import React, { Component } from 'react';
import { StringUtils } from '../utils';

class PracticeUnassignedClients extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  renderPracticeUnassignedClients = (clients) => {
    if (!clients || clients.length === 0) {
      return null
    }

    const notificationsDict = this.getUnassignedClientsNotifications();

    const clientRows = clients.map((client) => {
      var clientInfo = client.user_details && client.user_details[0] ? client.user_details[0] : null;
      var notification = notificationsDict && notificationsDict[client._id] ? notificationsDict[client._id] : {};
      var label = client.has_selected_provider === 'NO_PREFERENCE' ? 'No Preference' : '';
      label = client.has_selected_provider === 'NEW_CLIENT' ? 'New Client' : label;

      if (clientInfo) {
        return <div key={clientInfo._id} className='flex-container-row' style={{ justifyContent: 'space-between', marginBottom: 4, alignItems: 'center' }}>
          <div className='flex-container-column'>
            <span>{ StringUtils.displayName(clientInfo) }</span>
            <span style={{ color: 'grey', fontSize: 13, marginTop: -5 }}>{ label }</span>
          </div>
          <div className='flex-container-row' style={{ alignItems: 'center' }}>
            { notification._id ? <div style={{ height: 10, width: 10, borderRadius: 5, backgroundColor: 'red', marginRight: 10 }}></div> : null }
            <input type='submit'
                   value='Assign'
                   className='button-clear-blue'
                   onClick={ () => {
                     const token = this.props.token;
                     const notification_id = notification._id;

                     if (token && notification_id) {
                       this.props.notificationsActions.markNotificationAsSeen(token, notification_id);
                     }

                     this.props.practiceActions.openUnassignedClient(client);
                   }}
            />
          </div>
        </div>
      } else { return null };
    }).filter((row) => { return row });

    return <div className="basic-container">
      <div className="flex-container flex-container-column">
        <h4 style={{ marginBottom: 10 }}>Unassigned Clients</h4>
        { clientRows }
      </div>
    </div>
  }

  render() {

    const allClients = this.props.clients || [];
    const unassignedClients = this.getUnassignedClients(allClients);

    return this.renderPracticeUnassignedClients(unassignedClients);
  }

  getUnassignedClientsNotifications = () => {
    var notifications = this.props.notifications && this.props.notifications.notificationsTypeDict && this.props.notifications.notificationsTypeDict['new_unassigned_client'] ? this.props.notifications.notificationsTypeDict['new_unassigned_client'] : [];
    var dict = {};

    notifications.forEach((notification) => {
      if (notification && notification.data && notification.data.user_provider_id) {
        dict[notification.data.user_provider_id] = notification;
      }
    });

    return dict;
  }

  getUnassignedClients = (allClients) => {
    var unassigned = [];
    allClients.forEach((client) => {
      if (client && (client.has_selected_provider === 'NO_PREFERENCE' || client.has_selected_provider === 'NEW_CLIENT' || client.has_selected_provider === '')) {
        unassigned.push(client);
      }
    })

    return unassigned;
  }

}


export default PracticeUnassignedClients
